import { apiSlice } from "app/api/apiSlice"

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: credentials => ({
                url: '/auth/login',
                method: 'POST',
                body: { ...credentials }
            })
        }),

        getInfo: builder.query({
            query: () => '/user/info/me',
            method: 'GET',
            keepUnusedDataFor: 5,
        }),

        getPermissions: builder.query({
            query: () => '/user/permissions',
            method: 'GET',
            keepUnusedDataFor: 5,
        }),
        checkToken: builder.query({
            query: () => '/auth/check',
            method: 'GET',
            keepUnusedDataFor: 5,
        })
    })
})

export const {
    useLoginMutation,
    useGetInfoQuery,
    useLazyGetInfoQuery,
    useLazyGetPermissionsQuery,
    useLazyCheckTokenQuery
} = authApiSlice